import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.announcement;

export default {
  getData: (params) => http.post(api.search, params),
  getColumns: (params) => http.post(api.columns, params),
  review: {
    up: (uid) => http.post(api.action, { action: "up", uid }),
    down: (uid) => http.post(api.action, { action: "down", uid }),
    pass: (uid) => http.post(api.action, { action: "pass", uid }),
    veto: (uid) => http.post(api.action, { action: "veto", uid }),
  },
};
